<ng-container *ngIf="isTranslationLoaded">
  <div class="container">
    <app-sidenav (logoutEvent)="logout()"></app-sidenav>
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
  </div>

  <app-fallback [show]="!isLoggedIn && !isJoiningRoute"></app-fallback>
  <app-fullscreen-loading-spinner></app-fullscreen-loading-spinner>
</ng-container>
